import { memo } from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { MapAsset } from '@atom/types/map';
import { getColorFromColorId } from '@atom/utilities/colorUtilities';

import { getGoogleShapeCenter } from '../mapUtilities';

import LineStringMarker from './LineStringMarker';
import {
  getActiveAssetIconFromSchemaMarkerId,
  getInactiveAssetIconFromSchemaMarkerId,
} from './markerIconUtilities';
import {
  lineStringPath,
  MARKER_STYLE,
  resolveAnchor,
  resolveOpacity,
  resolveZIndex,
} from './markerUtilities';

type AssetSingleMarkerProps = {
  asset: MapAsset;
  isActive: boolean;
  disabled: boolean;
  onMarkerClick: (id: string, view: string) => void;
};

const AssetSingleMarker = ({
  asset,
  isActive,
  disabled,
  onMarkerClick,
}: AssetSingleMarkerProps) => {
  const position = getGoogleShapeCenter(asset.location);
  const path = lineStringPath(asset.location);
  const color = getColorFromColorId(asset.markerId);
  const svgUrl = isActive
    ? getActiveAssetIconFromSchemaMarkerId(asset.markerId)
    : getInactiveAssetIconFromSchemaMarkerId(asset.markerId);

  const handleClick = () => onMarkerClick(asset.id, 'asset');

  return (
    <>
      {path && (
        <LineStringMarker
          path={path}
          color={color}
          isActive={isActive}
          onClick={handleClick}
        />
      )}
      <AdvancedMarker
        position={position}
        zIndex={resolveZIndex('asset', isActive)}
        {...resolveAnchor('asset', isActive)}
        style={{ ...MARKER_STYLE, opacity: resolveOpacity(disabled) }}
        onClick={handleClick}
      >
        <img src={svgUrl} alt="" />
      </AdvancedMarker>
    </>
  );
};

export default memo(AssetSingleMarker);
